import styled from 'styled-components';
import StringField from 'Common/Components/StringField';
import colors from 'Styles/colors';

export const Wrapper = styled.div`
    display: flex;
    margin-bottom: 10px;
    overflow: auto;
    gap: 23px;
`;
Wrapper.displayName = 'Wrapper';

export const WrapperColumn = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-bottom: 10px;
    overflow: auto;
`;
Wrapper.displayName = 'Wrapper';

export const Row = styled.div`
    display: flex;
    margin-bottom: 6px;
`;
Row.displayName = 'Row';

export const FullRow = styled.div`
    width: 100%;
    margin-bottom: 20px;
`;
FullRow.displayName = 'FullRow';

export const Gap = styled.div`
    margin-top: 73px;
`;
Gap.displayName = 'Gap';

export const NewColumn = styled.div`
    display: flex;
    flex-direction: column;
    width: 406px;
    gap: 20px;
`;
Row.displayName = 'Row';

export const Column = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
`;
Column.displayName = 'Column';

export const ExternalId = styled(StringField)`
    box-shadow: ${({ theme }) => theme.shadows.inputs};
`;

ExternalId.displayName = 'ExternalId';

export const Input = styled(StringField)`
`;

Input.displayName = 'Input';

export const RightColumn = styled(Column)`
    & > :first-child{
        margin-bottom: 10px;
    }
`;
RightColumn.displayName = 'RightColumn';

export const PolicyColumn = styled(Column)`
    /* margin-right: 20px; */
    width: 48%;
`;
PolicyColumn.displayName = 'PolicyColumn';

export const AditionalText = styled.div`
    width: 220px;
    height: 36px;    
    font-size: 13.5px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.67;
    letter-spacing: 0.1px;
    color: #afb1bc;
    margin-left: 20px;
`;
AditionalText.displayName = 'AditionalText';

export const Title = styled.div`
    font-size: 12.5px;
    font-weight: 500;
    line-height: 2.08;
    color: ${({ theme }) => theme.text.modalLabel} !important;
    font-weight: 600;
    margin-bottom: 12px;
    ${({ required }) => required && `
        position: relative;
        &:after {
        content: '*';
        color: ${colors.redPink};
        position: absolute;
        top: 3px;
        margin-left: 3px;
        }
    `}  
`;
Title.displayName = 'Title';

export const CustomFieldsWrapper = styled(Wrapper)`
    width: 100%;
    flex-direction: column;
    padding-right: 5px;
`;
CustomFieldsWrapper.displayName = 'CustomFieldsWrapper';
